import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

@Component({
    selector: 'app-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss'],
    standalone: false
})
export class SearchComponent {
  form: FormGroup;

  @Input() value = '';
  @Output() valueChange = new EventEmitter<string>();

  constructor(private formBuilder: FormBuilder) {
    this.form = this.formBuilder.group({
      search: new FormControl(),
    });

    this.form.get('search')?.valueChanges.subscribe((value) => {
      this.valueChange.emit(value);
    });
  }
}
